export const REGISTER_PATH = '/sign_up'
export const LOGIN_PATH = '/sign_in'
export const FORGOT_PASSWORD_PATH = '/password/new'
export const TERMS_PATH = '/terms'
export const POLICIES_PATH = '/policies'
